// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Philippines from '../_raw/flag/icon_flag_philippines.png';

export default () => <img src={Philippines} alt="Philippines" />;
